import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "grids-wrapper d-flex fl-s-b"
};
var _hoisted_2 = {
  class: "h-100 d-flex fl-s-a fl-row booking-left-side",
  "data-cy": "sale-collections"
};
var _hoisted_3 = {
  class: "side-grids-buttons"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  key: 0,
  class: "selected-indicator"
};
var _hoisted_6 = {
  class: "cards-views-wrapper booking-right-side"
};
var _hoisted_7 = {
  key: 0
};
var _hoisted_8 = {
  key: 0
};
var _hoisted_9 = {
  key: 1
};
var _hoisted_10 = {
  key: 1
};
var _hoisted_11 = {
  key: 0
};
var _hoisted_12 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CalendarCards = _resolveComponent("CalendarCards");

  var _component_TicketsGrid = _resolveComponent("TicketsGrid");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grids, function (grid) {
    var _ctx$selectedGrid, _ctx$selectedGrid2;

    return _openBlock(), _createElementBlock("div", {
      key: grid.ticketGroupId,
      class: _normalizeClass(["grid-button", {
        selected: ((_ctx$selectedGrid = _ctx.selectedGrid) === null || _ctx$selectedGrid === void 0 ? void 0 : _ctx$selectedGrid.ticketGroupId) === grid.ticketGroupId
      }]),
      onClick: function onClick($event) {
        return _ctx.selectGrid(grid);
      },
      style: _normalizeStyle({
        'background-color': grid.buttonColor
      }),
      "data-cy": "sale-collection-button"
    }, [_createElementVNode("p", null, _toDisplayString(grid.name), 1), ((_ctx$selectedGrid2 = _ctx.selectedGrid) === null || _ctx$selectedGrid2 === void 0 ? void 0 : _ctx$selectedGrid2.ticketGroupId) === grid.ticketGroupId ? (_openBlock(), _createElementBlock("div", _hoisted_5)) : _createCommentVNode("", true)], 14, _hoisted_4);
  }), 128))])]), _createElementVNode("div", _hoisted_6, [!_ctx.selectedGrid ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_ctx.firstGrid.type === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(), _createBlock(_component_CalendarCards, {
    key: "grid-".concat(_ctx.firstGrid.ticketGroupId),
    ticketGroupId: _ctx.firstGrid.ticketGroupId
  }, null, 8, ["ticketGroupId"]))])) : _ctx.firstGrid.type === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(), _createBlock(_component_TicketsGrid, {
    key: "grid-".concat(_ctx.firstGrid.ticketGroupId),
    ticketGroupId: _ctx.firstGrid.ticketGroupId
  }, null, 8, ["ticketGroupId"]))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _ctx.selectedGrid ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_ctx.selectedGrid.type === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(), _createBlock(_component_CalendarCards, {
    key: "grid-".concat(_ctx.selectedGrid.ticketGroupId),
    ticketGroupId: _ctx.selectedGrid.ticketGroupId
  }, null, 8, ["ticketGroupId"]))])) : _ctx.selectedGrid.type === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(), _createBlock(_component_TicketsGrid, {
    key: "grid-".concat(_ctx.selectedGrid.ticketGroupId),
    ticketGroupId: _ctx.selectedGrid.ticketGroupId
  }, null, 8, ["ticketGroupId"]))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])]);
}